interface Environment {
  production: boolean;
  apiUrl: string;
  storageUrl: string;
  telasEmDesenvolvimento: boolean;
}

const environments: Record<string, Environment> = {
  // Ambiente de Produção
  'simplificaagro.com.br': {
    production: true,
    apiUrl: 'https://api.simplificaagro.com.br',
    storageUrl: 'https://storage.simplificaagro.com.br',
    telasEmDesenvolvimento: false,
  },

  // Ambiente de Staging
  'staging.simplificaagro.com.br': {
    production: true,
    apiUrl: 'https://api.simplificaagro.com.br',
    storageUrl: 'https://api.simplificaagro.com.br/storage',
    telasEmDesenvolvimento: true,
  },

  // Ambiente de Teste (sem SSL)
  'tst.simplificaagro.com.br': {
    production: true,
    apiUrl: 'http://api.tst.simplificaagro.com.br:81',
    storageUrl: 'http://api.tst.simplificaagro.com.br:81/storage',
    telasEmDesenvolvimento: true,
  },

  // Ambiente de Desenvolvimento Local
  'local.simplificaagro.com.br': {
    production: false,
    apiUrl: 'http://api.local.simplificaagro.com.br',
    storageUrl: 'http://api.local.simplificaagro.com.br/storage',
    telasEmDesenvolvimento: true,
  },

};

export const environment = (() => {
  const hostname = window.location.hostname.toLowerCase();

  if (!(hostname in environments)) {
    throw new Error(`Nenhum ambiente configurado para ${hostname}`);
  }

  return environments[hostname];
})();
